
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quelle est son efficacité?`}</em></p>
    <p>{`La protection contre une infection symptomatique est de 94% après la deuxième
injection chez les plus de 18 ans, selon les chiffres publiés par l'Office
fédéral de la santé publique.`}</p>
    <p>{`Des chercheurs des Centres américains de prévention et de lutte contre les
maladies (CDC) ont publié le 24 septembre
`}<a parentName="p" {...{
        "href": "https://www.cdc.gov/mmwr/volumes/70/wr/mm7038e1.htm"
      }}>{`une étude`}</a>{` après avoir
analysé un échantillon de près de 3700 adultes hospitalisés entre le 11 mars et
le 15 août 2021 en raison du Covid (avec des symptômes graves). Durant cette
période, le vaccin de Moderna s'est révélé efficace à 93% pour prévenir les
hospitalisations, contre 88% pour celui de Pfizer et 71% pour celui de
Johnson&Johnson.`}</p>
    <p>{`Les chercheurs notent que l'efficacité du vaccin de Pfizer a davantage chuté (de
91% sur la période de 14 à 120 jours après l'injection à 77% au-delà) que celle
du vaccin de Moderna (de 93 à 92%). Selon eux, ces écarts pourraient être dus à
une teneur en ARNm plus élevée dans le produit de Moderna ou à des différences
de calendrier entre les doses. Mais des disparités entre les groupes (qui n'ont
pas été prises en compte dans l'analyse) pourraient aussi les expliquer.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;